var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_29_115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3333 1.33333H4.66667C2.82572 1.33333 1.33333 2.82572 1.33333 4.66667V11.3333C1.33333 13.1743 2.82572 14.6667 4.66667 14.6667H11.3333C13.1743 14.6667 14.6667 13.1743 14.6667 11.3333V4.66667C14.6667 2.82572 13.1743 1.33333 11.3333 1.33333Z",
    stroke: "var(--stroke-0, #0A0A0A)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6667 7.58004C10.7489 8.13487 10.6542 8.70152 10.3958 9.19938C10.1375 9.69725 9.72876 10.101 9.22775 10.3532C8.72674 10.6053 8.15896 10.6931 7.60519 10.604C7.05142 10.5149 6.53984 10.2534 6.14322 9.85681C5.74661 9.4602 5.48515 8.94862 5.39604 8.39485C5.30693 7.84107 5.39471 7.2733 5.64688 6.77229C5.89906 6.27127 6.30279 5.86253 6.80065 5.6042C7.29852 5.34587 7.86517 5.2511 8.42 5.33337C8.98595 5.41729 9.5099 5.68101 9.91446 6.08558C10.319 6.49014 10.5827 7.01409 10.6667 7.58004Z",
    stroke: "var(--stroke-0, #0A0A0A)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6667 4.33333H11.6733",
    stroke: "var(--stroke-0, #0A0A0A)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.db2d00ad4dc606500597d49988997a20.svg";
export { ForwardRef as ReactComponent };